import { englishValidationMessages } from './messages';
import { getMaxLengthValidator } from './rawValidators';
export const makeMaxLengthValidation = (messages)=>(maxLength, fieldName)=>({
            validate: {
                maxLength: (value)=>getMaxLengthValidator(maxLength)(value) || (typeof fieldName === 'string' ? messages.tooLong({
                        field: fieldName,
                        max: maxLength
                    }) : false)
            }
        });
/** For react-hook-form library. */ export const maxLengthValidation = makeMaxLengthValidation(englishValidationMessages);
